<ng-container *appPermission="item.perms">
  @if(item.navCap){
  <div mat-subheader class="nav-caption" role="button" tabindex="0" [attr.aria-expanded]="expanded"
    (click)="onCapClick()" (keydown.enter)="onCapClick()" (keydown.space)="onCapClick()">
    <span>{{ item.navCap }}</span>
    <i-tabler name="chevron-down" class="caption-chevron" [class.rotated]="expanded"></i-tabler>
  </div>
  } @if(!item.navCap && !item.external && !item.twoLines) {
  <a mat-list-item (click)="onItemSelected(item)" [ngClass]="{
            'mat-toolbar mat-primary activeMenu': item.route
              ? router.isActive(item.route, item.subset ? false : true)
              : false,
          }" class="menu-list-item">
    <i-tabler class="routeIcon" name="{{ item.iconName }}" matListItemIcon></i-tabler>
    <span class="hide-menu">{{ item.displayName }}</span>

  </a>
  }

</ng-container>